<template>
  <div class="buttonlist">
    <div class="buttonlist-m">
      <el-form :inline="true" :model="filteForm" class="toolbar" @submit.native.prevent>
        <el-form-item label="日期">
          <el-date-picker v-model="filteForm.scheduledDate" type="date" value-format="yyyy-MM-dd" style="width:150px" @change="loadData" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="filteForm.statusList" multiple clearable collapse-tags placeholder="全部" style="width:200px" @change="loadData">
            <el-option label="待执行" :value="0" />
            <el-option label="执行中" :value="1" />
            <el-option label="已完成" :value="2" />
            <el-option label="已超时" :value="3" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain icon="el-icon-refresh" @click="loadData">刷新</el-button>
        </el-form-item>
      </el-form>
      <div v-loading="loading">
        <el-table :data="dataList" :row-style="rowStyle" :header-cell-style="headerStyle">
          <el-table-column label="时间" prop="scheduledTime" width="80" align="center" />
          <el-table-column label="老人" prop="oldmanName" width="90" align="center" />
          <el-table-column label="床位" prop="bedNo" width="80" align="center" />
          <el-table-column label="护理项目" prop="projectName" align="center" />
          <el-table-column label="状态" width="90" align="center">
            <template slot-scope="s">
              <el-tag :type="statusTag(s.row.status)" size="mini">{{ statusText(s.row.status) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="280" align="center" fixed="right">
            <template slot-scope="s">
              <el-button v-if="s.row.status === 0" type="primary" size="mini" plain @click="startTask(s.row)">开始</el-button>
              <el-button v-if="s.row.status === 1" type="success" size="mini" plain @click="openComplete(s.row)">完成</el-button>
              <el-button v-if="s.row.status === 1 || s.row.status === 3" type="danger" size="mini" plain @click="openException(s.row)">异常上报</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog title="完成打卡" :visible.sync="completeVisible" width="480px">
        <el-form label-width="80px">
          <el-form-item label="备注"><el-input v-model.trim="completeForm.remark" type="textarea" :rows="2" /></el-form-item>
        </el-form>
        <div slot="footer" align="center">
          <el-button @click="completeVisible = false">取消</el-button>
          <el-button type="primary" @click="submitComplete">确认完成</el-button>
        </div>
      </el-dialog>
      <el-dialog title="异常上报" :visible.sync="exceptionVisible" width="480px">
        <el-form label-width="90px">
          <el-form-item label="异常类型" required>
            <el-select v-model="exceptionForm.exceptionType" style="width:100%">
              <el-option label="跌倒" value="fall" />
              <el-option label="发热" value="fever" />
              <el-option label="不适" value="discomfort" />
              <el-option label="其他" value="other" />
            </el-select>
          </el-form-item>
          <el-form-item label="描述"><el-input v-model.trim="exceptionForm.description" type="textarea" :rows="3" /></el-form-item>
        </el-form>
        <div slot="footer" align="center">
          <el-button @click="exceptionVisible = false">取消</el-button>
          <el-button type="danger" @click="submitException">提交</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  name: "NursingTaskPunch",
  data() {
    const today = new Date();
    const d = today.getFullYear() + "-" + String(today.getMonth() + 1).padStart(2, "0") + "-" + String(today.getDate()).padStart(2, "0");
    return {
      filteForm: { scheduledDate: d, statusList: [0, 1, 3], pageNum: 1, pageSize: 100 },
      dataList: [],
      loading: false,
      completeVisible: false,
      completeForm: {},
      exceptionVisible: false,
      exceptionForm: {}
    };
  },
  methods: {
    loadData() {
      this.loading = true;
      this.$postJson("omc/nursingTask/monitorQuery", this.filteForm).then(res => {
        this.loading = false;
        if (res.code == 200 && res.result && res.result.tasks) {
          this.dataList = res.result.tasks.list || [];
        }
      }).catch(() => { this.loading = false; });
    },
    startTask(row) {
      this.$postJson("omc/nursingTask/start", { id: row.id }).then(res => {
        if (res.code == 200) { this.$message.success("已开始执行"); this.loadData(); }
        else this.$message.error(res.message);
      });
    },
    openComplete(row) { this.completeForm = { taskId: row.id, remark: "" }; this.completeVisible = true; },
    submitComplete() {
      this.$postJson("omc/nursingTask/complete", this.completeForm).then(res => {
        if (res.code == 200) { this.$message.success("打卡完成"); this.completeVisible = false; this.loadData(); }
        else this.$message.error(res.message);
      });
    },
    openException(row) { this.exceptionForm = { taskId: row.id, exceptionType: "other", description: "" }; this.exceptionVisible = true; },
    submitException() {
      this.$postJson("omc/nursingTask/reportException", this.exceptionForm).then(res => {
        if (res.code == 200) { this.$message.success("已上报"); this.exceptionVisible = false; }
        else this.$message.error(res.message);
      });
    },
    statusText(s) { return ["待执行", "执行中", "已完成", "已超时", "已取消"][s] || ""; },
    statusTag(s) { return ["", "warning", "success", "danger", "info"][s] || ""; },
    rowStyle() { return "background:#fff;font-size:14px"; },
    headerStyle({ rowIndex }) { if (rowIndex === 0) return "background:#d4f5fa;font-weight:600"; }
  },
  mounted() { this.loadData(); }
};
</script>
